import React from "react";
import { bool, func } from "prop-types";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";

// import I18n from "pages/_components/I18n";

// eslint-disable-next-line no-confusing-arrow
const EnvironmentWelcomeSlide = ({ isMobile, slideIsVisible, closeSlide }) =>
    isMobile ? null : (
        <Drawer className="qr-slider" openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
            <div className="container">
                <h2 className="title-content">
                    <CustomText text="¡Hola nuevamente!" />
                </h2>

                <div className="illustration-alta-persona">
                    <Image src="images/figma/illustrations/onboarding11.svg" className="svg-image" />
                </div>
            </div>
        </Drawer>
    );

EnvironmentWelcomeSlide.propTypes = {
    isMobile: bool.isRequired,
    slideIsVisible: bool.isRequired,
    closeSlide: func.isRequired,
};

export default EnvironmentWelcomeSlide;
